module.exports = __webpack_public_path__ + "img/controlli-emt.1df5701e.png";